import { useMassBalancePage } from '../../contexts/MassBalancePageContext'
import { useEffect, useState }            from 'react'
import api                      from '../../services/api'

const MassBalanceProductFilter = () => {
    
    const { selectedTerminal,selectedProducts,
            setSelectedProducts } = useMassBalancePage();
    
    const [ products, setProducts] = useState([])
    

    useEffect(()=>{

        // Evita que a resposta de um terminal antigo sobrescreva a do atual.
        let cancelled = false

        const fetchProductsFromTerminalId = async () => {
            
            try{
                
                if (selectedTerminal){

                    // "Todos" traz a lista de terminais; um terminal só vira uma lista de um.
                    const terminais = selectedTerminal.isAll ? selectedTerminal.terminals : [selectedTerminal]

                    const responses = await Promise.all(
                        terminais.map((terminal) => api.get(`getTerminalProductId/${terminal.id}`))
                    )

                    if (cancelled) return

                    // Produtos de mesmo nome viram um botão só. Cada um guarda o id
                    // que tem em cada terminal (idByTerminal), usado na busca da tabela.
                    const productsByName = new Map()

                    responses.forEach((response, index) => {
                        (response.data || []).forEach((product) => {
                            const merged = productsByName.get(product.name) || { ...product, idByTerminal: {} }

                            merged.idByTerminal[terminais[index].id] = product.id
                            productsByName.set(product.name, merged)
                        })
                    })

                    const productList = [...productsByName.values()]

                    setProducts(productList)
                    setSelectedProducts(productList[0] ? [productList[0]] : [])
                }

            }catch(error){
                console.log(error)
            }

        }


        fetchProductsFromTerminalId();

        return () => { cancelled = true }
   
    },[selectedTerminal])
    
    return (
        
        
        <section 
            className="w-full bg-neutro borda-cinza rounded-[7px] p-[1rem] flex justify-between gap-[10px]"
        >
        

            {products.map((product, index) => (
                <button 
                    
                    key={index}
                    data-index={index}
                    className={

                        `w-full [transition:0.3s_ease] text-[0.8rem] outline-[none] border-[none] p-[4px] rounded-[4px] cursor-pointer font-saira
                        ${selectedProducts.includes(product) ? 'bg-azul-profundo-m text-white' : 'bg-white text-black hover:bg-azul-profundo-c hover:text-white'}
                        hover:bg-azul-profundo-c hover:text-white z-9 h-10 w-[215px] `

                        }
                        onClick={(event) => {
                            if (!event.shiftKey) {
                                setSelectedProducts([product])
                                return
                            }

                            setSelectedProducts((atual) => {
                                if (!atual.includes(product)) {
                                    return [...atual, product]
                                }

                                // Nunca deixa a seleção vazia.
                                return atual.length > 1 ? atual.filter((p) => p !== product) : atual
                            })
                        }}
                >
                    {product.name}
                </button>
            ))}

        </section>
    )
}

export default MassBalanceProductFilter